<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-main>
      <el-container style="height: 100%">
        <el-aside width="35rem" class="panel_aside">
          <el-container style="height: 100%">
            <el-header
              class="panel-header"
              style="text-align: left; padding: 4px 4px; height: 42px"
            >
              <div class="panel-tabs">
                <el-tabs
                  class="custom-tabs"
                  v-model="activeName"
                  @tab-click="handleClick"
                >
                  <el-tab-pane label="设备类型" name="first"></el-tab-pane>
                </el-tabs>
              </div>
            </el-header>
            <el-divider style="top: -18px"></el-divider>
            <el-main>
              <el-tree
                show-checkbox
                ref="treeRef"
                style="height: 100%;"
                :data="typeList"
                node-key="id"
                :props="defaultProps"
                default-expand-all
                check-on-click-node
                :default-checked-keys="checked"
                @check="checkHdl"
              >
                <!-- check-strictly -->
                <span class="custom-tree-node" slot-scope="{ node }">
                  <span class="custom-tree-node-label">
                    {{ node.label }}
                  </span>
                </span>
              </el-tree>
            </el-main>
          </el-container>
        </el-aside>
        <el-container style="height: 100%">
          <el-header
            class="panel-header"
            style="text-align: left; padding: 4px 4px; height: 42px"
          >
            <div class="panel-tabs">
              <el-tabs
                class="custom-tabs"
                v-model="activeName"
                @tab-click="handleClick"
              >
                <el-tab-pane label="设备清单" name="first"></el-tab-pane>
              </el-tabs>
            </div>
          </el-header>
          <el-divider style="top: -18px"></el-divider>
          <el-main>
            <el-row style="height: 100%;overflow: auto;">
              <el-col :span="4" v-for="(item, index) in Devices" :key="index">
                <div
                  class="main-content-card"
                  @click="deviceClick(item, index)"
                  :class="{ 'main-card-checked': activeDeviceIndex == index }"
                >
                  <!-- <div class="main-content-card" @click="deviceClick(item, index)" :class="{'main-card-checked' :activeDeviceIndex == index, 'main-card-disabled': item.onLine === '0'}"> -->
                  <div
                    class="card-device-status"
                    :class="item.onLine === '0' ? 'red' : 'green'"
                  ></div>
                  <div class="card-device">
                    <span
                      ><i>{{ item.deviceName }}</i></span
                    >
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-main>
        </el-container> 
        <!-- <el-aside width="40rem" class="panel_aside">
          <el-container style="height: 100%">
            <el-header
              class="panel-header"
              style="text-align: left; padding: 4px 4px; height: 42px"
            >
              <div class="panel-tabs">
                <el-tabs
                  class="custom-tabs"
                  v-model="activeName"
                  @tab-click="handleClick"
                >
                  <el-tab-pane label="设备详情" name="first"></el-tab-pane>
                </el-tabs>
              </div>
            </el-header>
            <el-divider style="top: -18px"></el-divider>
            <el-main>
              <el-form
                :model="form"
                ref="form"
                label-width="10rem"
                style="width: 100%;height: 100%;overflow: auto;"
              >
                <el-form-item
                  :label="item.label + ':'"
                  v-for="item in form.list"
                >
                  <div style="word-wrap: break-word;">{{ item.value }}</div>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-aside> -->
        <el-dialog title="设备详情" :visible.sync="handle" width="1500px"  append-to-body>
          <el-form
                :model="form"
                ref="form"
                label-width="140px"
                style="width: 100%;height:600px;overflow: auto;"
                class="formBox"
              >
                <el-form-item
                  class="itemOne"
                  v-for="(item,index) in form.list"
                  :label="item.label + ':'"
                  :key="index"
                >
                <!-- style="word-wrap: break-word;" -->
                <el-tooltip class="item" effect="dark" :content="item.value" placement="top-start">
                  <div class="itemValue">{{ item.value }}</div>
                </el-tooltip>
                  
                </el-form-item>
              </el-form>
          <div slot="footer" class="dialog-footer">
              <!-- <el-button @click="cancelHandle">取 消</el-button> -->
              <el-button type="primary" @click="handle=false">确 定</el-button>
          </div>
      </el-dialog>


      </el-container>
    </zj-layout-main>
  </zj-layout-container>
</template>

<script>
import {
  getDeviceList,
  getDeviceStatusInfo,
  getDeviceType,
} from "@/api/src/data2-server";
// import { nextTick } from "vue";
// import { list } from "@/api/src/emergency_feedback";
export default {
  name: "DeviceView",
  controller: "UI",
  action: "DeviceView",
  data() {
    return {
      loading: false,
      loadingText: "",
      activeName: "first",
      defaultProps: {
        value: "id",
        // disabled:(data) => {
        //   return data.children&& data.children.length ? true : false
        // }
      },
      checked: [],
      typeList: [],
      Devices: [],
      form: {
        list: [],
      },
      activeDeviceIndex: -1,
      topId: 0,
      // 是否显示弹出层
      handle: false,
    };
  },
  created: function() {},
  mounted: function() {
    this.getTypeList()
    this.getDevices()
    // let obj = {
    //   "主键（唯一标识）": "--",
    //   设备编号: "--",
    //   状态: "--",
    //   数据统计所属时间: "--",
    //   状态2: "--",
    //   电压: "--",
    //   电量: "--",
    //   太阳能板电压: "--",
    //   电池剩量百分比: "--",
    //   设备所处温度: "--",
    //   设备所处环境湿度: "--",
    //   设备所处位置经度: "--",
    //   设备所处位置纬度: "--",
    //   "4G 网络信号强度": "--",
    //   "NBIot 网络信号强度": "--",
    //   北斗信号强度: "--",
    //   固件版本号: "--",
    //   功放状态: "--",
    //   拾音反馈状态码: "--",
    //   "RTU 管理的所有传感器的状态信息": "--",
    // };
    // this.form.list = this.resetData(obj);
    // this.typeList = [
    //   {
    //     id: "100",
    //     label: "物联网中台",
    //     children: [
    //       {
    //         id: "128",
    //         label: "山西省地址灾害预警平台",
    //         children: [
    //           {
    //             id: "136",
    //             label: "激光测距仪",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "129",
    //             label: "喇叭",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "130",
    //             label: "gnss",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "131",
    //             label: "拉线裂缝",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "132",
    //             label: "雨量",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "133",
    //             label: "倾角加速度计",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "134",
    //             label: "数据采集仪",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "135",
    //             label: "路由器",
    //             iotDevices: [],
    //           },
    //         ],
    //         iotDevices: [],
    //       },
    //       {
    //         id: "142",
    //         label: "森林防火",
    //         children: [
    //           {
    //             id: "149",
    //             label: "摄像头",
    //             iotDevices: [],
    //           },
    //         ],
    //         iotDevices: [],
    //       },
    //       {
    //         id: "143",
    //         label: "国土资源监测",
    //         children: [
    //           {
    //             id: "152",
    //             label: "倾角加速度计",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "153",
    //             label: "拉线裂缝计",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "154",
    //             label: "B85视频位移",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "155",
    //             label: "雨量计",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "156",
    //             label: "土壤水分计",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "157",
    //             label: "GNSS设备",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "158",
    //             label: "渗压计",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "159",
    //             label: "量水堰计",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "160",
    //             label: "视频设备",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "161",
    //             label: "水位计",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "162",
    //             label: "深部位移计",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "163",
    //             label: "声光报警器",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "164",
    //             label: "普通野保相机",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "165",
    //             label: "在线野保相机",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "166",
    //             label: "虫情测报灯",
    //             iotDevices: [],
    //           },
    //         ],
    //         iotDevices: [],
    //       },
    //       {
    //         id: "150",
    //         label: "服务器信息",
    //         children: [
    //           {
    //             id: "2383601062742528",
    //             label: "系统",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "2383601181837824",
    //             label: "配电",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "2383601250363904",
    //             label: "通道",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "2383601317407232",
    //             label: "制冷",
    //             iotDevices: [],
    //           },
    //           {
    //             id: "2383601397082624",
    //             label: "机柜",
    //             iotDevices: [],
    //           },
    //         ],
    //         iotDevices: [],
    //       },
    //       {
    //         id: "151",
    //         label: "智慧水务",
    //         iotDevices: [],
    //       },
    //     ],
    //   },
    // ];
    // this.activeDeviceIndex = 0;
    // this.Devices = [
    //   {
    //     createBy: null,
    //     createTime: "2024-01-18 17:01:18",
    //     updateBy: null,
    //     updateTime: "2024-01-30 16:45:34",
    //     remark: null,
    //     id: "165",
    //     categoryId: "136",
    //     deviceCategory: 1,
    //     deviceNo: "",
    //     deviceName: "WXLF",
    //     productId: "14",
    //     status: "0",
    //     onLine: "0",
    //     lon: "",
    //     lat: null,
    //     location: null,
    //     content: null,
    //     categoryName: "激光测距仪",
    //     productName: "娄烦县静游镇河杨树底村北崩塌隐患",
    //   },
    //   {
    //     createBy: null,
    //     createTime: "2024-01-18 17:01:18",
    //     updateBy: null,
    //     updateTime: "2024-01-30 16:45:32",
    //     remark: null,
    //     id: "121",
    //     categoryId: "136",
    //     deviceCategory: 1,
    //     deviceNo: "",
    //     deviceName: "WXLF",
    //     productId: "9",
    //     status: "0",
    //     onLine: "0",
    //     lon: "",
    //     lat: null,
    //     location: null,
    //     content: null,
    //     categoryName: "激光测距仪",
    //     productName: "娄烦县天池店乡王家崖村墓塔卯崩塌隐患",
    //   },
    // ];
    // this.checked = ["100"];
    // this.$nextTick(() => {
    //   this.$refs.treeRef.setCheckedKeys(["100"]);
    // });
  },

  methods: {
    //列表样式
    selectionStyle({ columnIndex }) {
      if (columnIndex === 0) {
        return `padding:7px 0 40px 8px;`;
      } else {
        return "";
      }
    },
    setLoading(flag) {
      if (flag) {
        this.loading = true;
        this.loadingText = "加载中。。。";
      } else {
        this.loading = false;
        this.loadingText = "";
      }
    },
    getTypeList() {
      this.setLoading(true);
      getDeviceType()
        .then((res) => {
          if (res.code == 200 && res.data && res.data.length) {
            this.typeList = res.data;
            this.topId = res.data[0].id;
            this.checked = [this.topId];
            this.$nextTick(() => {
              this.$refs.treeRef.setCheckedKeys([this.topId]);
            });
          } else {
            this.setLoading(false);
          }
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
    getDevices(id) {
      this.setLoading(true);
      this.form.list = [];
      let param = {};
      if (id && id != this.topId) {
        param.id = id;
      }
      getDeviceList(param)
        .then((res) => {
          if (res.code == 200 && res.data && res.data.length) {
            this.Devices = res.data;
            // this.activeDeviceIndex = 0;
            // this.getDeviceDetail(res.data[0].id);
            this.setLoading(false);
          } else {
            this.Devices = [];
            this.activeDeviceIndex = -1;
            this.setLoading(false);
          }
        })
        .catch(() => {
          this.Devices = [];
          this.activeDeviceIndex = -1;
          this.setLoading(false);
        });
    },
    getDeviceDetail(id) {
      this.setLoading(true);
      getDeviceStatusInfo(id)
        .then((res) => {
          if (res.code == 200 && res.data && res.data.result) {
            this.setLoading(false);
            this.form.list = this.resetData(res.data.result);
          } else {
            this.form.list = [];
            this.setLoading(false);
          }
          this.handle = true;
        })
        .catch((err) => {
          console.log(err)
          this.form.list = [];
          this.setLoading(false);
        });
    },
    resetData(obj) {
      let keys = Object.keys(obj),
        arr = [];
      keys.map((item) => {
        arr.push({
          label: item,
          value: obj[item],
        });
      });
      return arr;
    },
    //设备类型选择更新设备列表状态
    checkHdl(data) {
      this.$refs.treeRef.setCheckedKeys([data.id]);
      this.getDevices(data.id);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 绑定设备状态
    deviceClick(item, index) {
      console.log(item, index);
      // if(item.onLine === '0') return
      this.activeDeviceIndex = index;
      this.getDeviceDetail(item.id);
    },
  },
};
</script>
<style lang="scss">
.panel_aside {
  padding: 0px 20px 20px 20px;
  .el-tree {
    background-color: transparent;

    border-width: 1;

    * {
      background-color: transparent;
    }
    .el-tree-node > .el-tree-node__children {
      overflow: unset;
    }
  }
  .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: rgba(61, 159, 255, 0.2);
  }
  .el-checkbox__inner {
    border-radius: 50%;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-radius: 50%;
    background: -webkit-radial-gradient(
      circle closest-side,
      #409eff 60%,
      transparent 40%
    );
  }

  .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner::after {
    border-color: transparent;
  }
}
.panel-header {
  text-align: left;
  padding: 4px 4px;
  height: 42px;
  .panel-tabs {
    float: left;
  }
}
.main-card-checked {
  border: 1px solid rgb(61, 159, 255);
}
.main-card-disabled {
  pointer-events: none;
}
.main-content-card {
  position: relative;
  height: 8rem;
  padding: 0.7rem;
  background-color: rgba(61, 159, 255, 0.2);
  margin: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  .card-device-status {
    flex: 0 0 auto;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    margin-right: 0.4rem;
  }
  .red {
    background-color: red;
  }
  .green {
    background-color: green;
  }
  .card-device {
    width: 100%;
    font-size: 14px;
    // height: 100%;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // -o-text-overflow: ellipsis;
    // white-space: nowrap;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
    
  }
}
.el-form-item {
  margin-bottom: 1.2rem;
  .el-form-item__label {
    // line-height: 1.2em;
    color: #9ab9ca;
  }
  .el-form-item__content {
    // line-height: 1.2em;
    color: #d6f0ff;
  }
}
.dialog-footer{
  display: flex;
  align-items: center;
  justify-content: center;
  padding:3rem 0rem;
}
.formBox{
   display: flex;
   align-items: center;
   flex-wrap: wrap;
   padding:10px 30px;
   .itemOne{
    width: 25%;
    font-size: 26px;
   }
   .el-form-item .el-form-item__label {
    font-size: 1.6rem;
   }
   .itemValue{
    font-size: 1.8rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
   }
} 
.el-dialog__headerbtn{
  right:7rem !important;
  top:4rem !important;
}
</style>
